<!-- /****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->

<div class="entity-attributes">
  @if (hasTemplate) {
    <div>
      @if (pageId===test) {
        <entity-attribute-test #entityTemplate></entity-attribute-test>
      }
    </div>
  }
  @if (entityAttributes) {
    <div class="entity-attributes-section">
      <form [formGroup]="attributeFormGroup">
        @for (attributeSection of entityAttributes.entityAttributeSections; track attributeSection; let i = $index) {
          <div>
            @if (attributeSection.attributes && attributeSection.attributes.length) {
              <mat-card class="section-card">
                <span class="section-name">{{attributeSection.sectionLabelKey}}</span>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                  @for (attribute of attributeSection.attributes; track attribute) {
                    <div style="justify-content: flex-start; align-items: center; flex: 1 1 50%; max-width: 50%; box-sizing: border-box">
                      @if (attribute.htmlType==='TEXT' || attribute.htmlType==='SELECT'  ) {
                        <mat-form-field class="form-field">
                          @if (attribute.htmlType==='TEXT' && (!attribute.hasSuggestions || !attribute.suggestedValues || !attribute.suggestedValues.length)) {
                            <div>
                              <input id="entity_labelKey_{{i}}" class="" type="text" placeholder="{{attribute.labelKey}}" matInput formControlName="{{'attribute'+attribute.userFieldName}}"
                                [required]="attribute.attributeConstraint?.mandatory">
                              </div>
                            }
                            @if (attribute.htmlType==='TEXT' && attribute.hasSuggestions && attribute.suggestedValues && attribute.suggestedValues.length) {
                              <div>
                                <input id="entity_labelKey_{{i}}" class="" type="text" placeholder="{{attribute.labelKey}}" matInput formControlName="{{'attribute'+attribute.userFieldName}}"
                                  [required]="attribute.attributeConstraint?.mandatory" [matAutocomplete]="auto">
                                  <mat-autocomplete #auto="matAutocomplete">
                                    @for (option of attribute.suggestedValues; track option) {
                                      <mat-option [value]="option">
                                        {{ option }}
                                      </mat-option>
                                    }
                                  </mat-autocomplete>
                                </div>
                              }
                              @if (attribute.htmlType==='SELECT') {
                                <mat-select placeholder="{{attribute.labelKey}}" formControlName="{{'attribute'+attribute.userFieldName}}"
                                  [required]="attribute.attributeConstraint?.mandatory">
                                  <mat-option value="">
                                    -- Select --
                                  </mat-option>
                                  @for (item of attribute.suggestedValues; track item) {
                                    <mat-option [value]="item">
                                      {{ item }}
                                    </mat-option>
                                  }
                                </mat-select>
                              }
                              @if (attributeFormGroup.controls['attribute'+attribute.userFieldName].hasError('required')) {
                                <mat-error>
                                  {{ attribute.labelKey }} is required
                                </mat-error>
                              }
                              @if (!attributeFormGroup.controls['attribute'+attribute.userFieldName].hasError('required') && attributeFormGroup.controls['attribute'+attribute.userFieldName].hasError('pattern')) {
                                <mat-error>
                                  {{ attribute.attributeConstraint?.regexErrorKey }}
                                </mat-error>
                              }
                            </mat-form-field>
                          }
                          @if (attribute.htmlType==='DATE') {
                            <mat-form-field class="form-field">
                              <input id="entity_attribute_{{i}}" readonly [min]="todayDate" matInput [matDatepicker]="attrdate" placeholder="{{attribute.labelKey}}"
                                formControlName="{{'attribute'+attribute.userFieldName}}" [required]="attribute.attributeConstraint?.mandatory">
                                <mat-datepicker-toggle matSuffix [for]="attrdate"></mat-datepicker-toggle>
                                <mat-datepicker #attrdate></mat-datepicker>
                                @if (attributeFormGroup.controls['attribute'+attribute.userFieldName].hasError('required')) {
                                  <mat-error>
                                    {{ attribute.labelKey }} is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            }
                            @if (attribute.htmlType==='BOOLEAN') {
                              <div>
                                <mat-slide-toggle id="entity_labelKey_{{i}}" [checked]="attributeFormGroup.controls['attribute'+attribute.userFieldName].value"
                                  formControlName="{{'attribute'+attribute.userFieldName}}">
                                  {{attribute.labelKey}}
                                </mat-slide-toggle>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </mat-card>
                  }
                </div>
              }
              @for (attributeSection of customEntityAttributes?.entityAttributeSections; track attributeSection; let i = $index) {
                <div>
                  @if (attributeSection.attributes && attributeSection.attributes.length) {
                    <mat-card class="section-card">
                      <span class="section-name">{{attributeSection.sectionLabelKey}}</span>
                      <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                        @for (attribute of attributeSection.attributes; track attribute) {
                          <div style="flex: 1 1 50%; max-width: 50%; box-sizing: border-box">
                            @if (attribute.htmlType==='TEXT' || attribute.htmlType==='SELECT') {
                              <mat-form-field class="form-field">
                                @if (attribute.htmlType==='TEXT' && (!attribute.hasSuggestions || !attribute.suggestedValues || !attribute.suggestedValues.length)) {
                                  <div>
                                    <input id="entity_labelKey_{{i}}" class="" type="text" placeholder="{{attribute.labelKey}}" matInput formControlName="{{'attribute'+ userFieldName + attribute.key}}"
                                      [required]="attribute.attributeConstraint?.mandatory">
                                    </div>
                                  }
                                  @if (attribute.htmlType==='TEXT' && attribute.hasSuggestions && attribute.suggestedValues && attribute.suggestedValues.length) {
                                    <div>
                                      <input id="entity_labelKey_{{i}}" class="" type="text" placeholder="{{attribute.labelKey}}" matInput formControlName="{{'attribute'+ userFieldName + attribute.key}}"
                                        [required]="attribute.attributeConstraint?.mandatory" [matAutocomplete]="auto">
                                        <mat-autocomplete #auto="matAutocomplete">
                                          @for (option of attribute.suggestedValues; track option) {
                                            <mat-option [value]="option">
                                              {{ option }}
                                            </mat-option>
                                          }
                                        </mat-autocomplete>
                                      </div>
                                    }
                                    @if (attribute.htmlType==='SELECT') {
                                      <mat-select placeholder="{{attribute.labelKey}}" formControlName="{{'attribute'+ userFieldName + attribute.key}}"
                                        [required]="attribute.attributeConstraint?.mandatory">
                                        <mat-option value="">
                                          -- Select --
                                        </mat-option>
                                        @for (item of attribute.suggestedValues; track item) {
                                          <mat-option [value]="item">
                                            {{ item }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    }
                                    @if (attributeFormGroup.controls['attribute'+ userFieldName + attribute.key].hasError('required')) {
                                      <mat-error>
                                        {{ attribute.labelKey }} is required
                                      </mat-error>
                                    }
                                    @if (!attributeFormGroup.controls['attribute'+ userFieldName + attribute.key].hasError('required') && attributeFormGroup.controls['attribute'+ userFieldName + attribute.key].hasError('pattern')) {
                                      <mat-error>
                                        {{ attribute.attributeConstraint?.regexErrorKey }}
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                }
                                @if (attribute.htmlType==='DATE') {
                                  <mat-form-field class="form-field">
                                    <input id="entity_attribute_{{i}}" readonly [min]="todayDate" matInput [matDatepicker]="attrdate" placeholder="{{attribute.labelKey}}"
                                      formControlName="{{'attribute'+ userFieldName}}" [required]="attribute.attributeConstraint?.mandatory">
                                      <mat-datepicker-toggle matSuffix [for]="attrdate"></mat-datepicker-toggle>
                                      <mat-datepicker #attrdate></mat-datepicker>
                                      @if (attributeFormGroup.controls['attribute'+ userFieldName + attribute.key].hasError('required')) {
                                        <mat-error>
                                          {{ attribute.labelKey }} is required
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  }
                                  @if (attribute.htmlType==='BOOLEAN') {
                                    <div>
                                      <mat-slide-toggle id="entity_labelKey_{{i}}" [checked]="attributeFormGroup.controls['attribute'+ userFieldName + attribute.key].value"
                                        formControlName="{{'attribute'+ userFieldName + attribute.key}}">
                                        {{attribute.labelKey}}
                                      </mat-slide-toggle>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </mat-card>
                        }
                      </div>
                    }
                  </form>
                </div>
              }
            </div>


